interface NuxtContext {
	redirect: (
		location:
			| string
			| {
					name?: string;
					path?: string;
					params?: Record<string, string>;
					query?: Record<string, string>;
			  },
	) => void;
	[key: string]: any;
}

/**
 * Middleware che reindirizza automaticamente alla dashboard
 * Utilizzato tipicamente per route che dovrebbero sempre portare alla dashboard
 *
 * @param context - Contesto Nuxt con funzioni di routing
 */
export default function redirectToDashboard(context: NuxtContext): void {
	return context.redirect('/dashboard');
}
